import Link from "next/link";
import Footer from "../../globalModule/components/footer";
import styles from "../styles/specs.module.css";
import { useRouter } from "next/router";
export default function PrivacyPolicy() {
  const router = useRouter();
  return <div data-sentry-component="PrivacyPolicy" data-sentry-source-file="ContentPolicy.jsx">
      <seciton className={styles.privacy} data-sentry-element="seciton" data-sentry-source-file="ContentPolicy.jsx">
        <main className={styles.content}>
          <h1>
            <strong>UTSAV APP CONTENT POLICY</strong>
          </h1>
          <p>
            <em>Last updated: 22nd Nov 2024</em>
          </p>
          <p>
            These Content and Community Guidelines (&quot;Guidelines&quot;)
            govern your use of our website located at{" "}
            <Link href="https://utsavapp.in/" rel="alternate" hrefLang={router.locale} data-sentry-element="Link" data-sentry-source-file="ContentPolicy.jsx">
              https://utsavapp.in
            </Link>
            &nbsp;and/or the Utsav App mobile application (collectively, the
            &quot;Platform&quot;) and is made available by Nirvann Applications
            Private Limited (Formerly known as Applex Technologies Private
            Limited) (&quot;Utsav App&quot;, &quot;Company&quot;,
            &quot;we&quot;, &quot;us&quot; and &quot;our&quot;), a private
            company established under the laws of India having its registered
            office in Kolkata.&nbsp;
          </p>
          <p>
            The terms &quot;you&quot; and &quot;your&quot; refer to the user of
            the Platform.
          </p>
          <p>
            These Guidelines are to be read with{" "}
            <Link href="https://utsavapp.in/terms-of-use/" rel="alternate" hrefLang={router.locale} data-sentry-element="Link" data-sentry-source-file="ContentPolicy.jsx">
              Utsav App Terms of Use
            </Link>{" "}
            and{" "}
            <Link href="https://utsavapp.in/privacy-and-cookie-policy/" rel="alternate" hrefLang={router.locale} data-sentry-element="Link" data-sentry-source-file="ContentPolicy.jsx">
              Utsav App Privacy and Cookie Policy
            </Link>
            . The capitalised words used in these guidelines shall have the
            meaning given to such words in the Terms.
          </p>
          <p>
            Please note that we may change these Guidelines from time to time
            and we reserve the right to do so.
          </p>
          <p>
            Our Platform connects you with people from across India and other
            parts of the world. The community that we have created is diverse
            and receptive to a variety of content, but the Platform is accessed
            by a variety of audience, which may include minors and young adults.
            Hence, in order to ensure that all our users follow a standard
            practice and to foster a safe environment for you to creatively
            express yourselves, we have put in place strict guidelines and
            restrictions which govern the usage of the Platform .
          </p>
          <h3>
            <strong>CONTENT GUIDELINES</strong>
          </h3>
          <p>
            We actively delete content that is not permitted on our Platform and
            breaches both our Guidelines and Indian laws. If we become aware of
            such content, we may remove it or suspend user accounts. If you come
            across any content that violates our Guidelines, please report it to
            us. The creator&apos;s intention is critical. We recognise the value
            of creative expression, but we do not accept anything that is
            intended to cause discomfort, disseminate hate speech and abuse, or
            advocate violence and criminal actions.
          </p>
          <h5>
            <strong>a. Adherence to Applicable Laws</strong>
          </h5>
          <p>
            All content, including without limitation, content that is uploaded,
            posted, commented on, or shared by you on our Platform, must adhere
            to the laws of India, including without limitation, the Indian Penal
            Code, 1860 and, the Information Technology Act, 2000 along with all
            rules and amendments made under such laws. In situations of
            violation of applicable laws, we collaborate with legal authorities
            and use enforcement procedures. You may not publish, post, comment
            on, or distribute content that jeopardises India&apos;s unity,
            integrity, defence, security, or sovereignty, cordial relations with
            foreign states, or public order. You may not publish or interact
            with anything that is derogatory to another country, incites the
            conduct of crimes, or obstructs the investigation of crimes.
          </p>
          <h5>
            <strong>b. Nudity and Pornography</strong>
          </h5>
          <p>
            We allow content that may have limited sexual imagery, provided it
            is posted for artistic and educational purposes, public awareness,
            humour or satirical purposes. Content which contains the following
            is prohibited on the Platform and will be considered as a strict
            violation of these Guidelines:
          </p>
          <ol>
            <li>
              <p>
                obscene,sexually explicit, pornographic or nude material or
                images/videos that expose private parts (sexual organs, female
                breasts and nipples, buttocks) and/or portray sexual activities;
              </p>
            </li>
            <li>
              <p>
                videos or images of people in compromising positions or content
                which portrays sexual actions or fetish or erotic intent or
                sexual arousal;
              </p>
            </li>
            <li>
              <p>sextortion or revenge pornography;</p>
            </li>
            <li>
              <p>Bestiality or zoophilia;</p>
            </li>
            <li>
              <p>
                content that exploits or endangers any person (for example,
                listing of phone numbers, or other personal information aimed at
                any exploitation or endangerment of a person including for the
                purposes of encouraging or soliciting prostitution or escort
                services);
              </p>
            </li>
            <li>
              <p>
                content that is paedophilic or related to child pornography
                (including without limitation, creation, promotion,
                glorification, transmission or browsing of child pornography);
                or
              </p>
            </li>
            <li>
              <p>
                content that is indecent, immoral or related to rape, sexual
                objectification, non-consensual activities and molestation.
              </p>
            </li>
          </ol>
          <h5>
            <strong>c. Harassment or Bullying</strong>
          </h5>
          <p>
            We strongly condemn any kind of harassment or bullying on our
            Platform. We intend to give our users the freedom to express
            themselves without the fear of emotional or psychological distress.
            We urge you to ignore any content that you may find petty and
            annoying. In addition to this, we also encourage you to report any
            such content that harasses another person or intends to degrade or
            shame any individual.
          </p>
          <p>
            Content which qualifies as a violation of these Guidelines includes,
            but is not limited to:
          </p>
          <ol>
            <li>
              <p>
                Posting abusive language or curse words, morphed images, and/or
                malicious recordings.
              </p>
            </li>
            <li>
              <p>
                Objectifying, insulting or harassing someone based on their
                race, caste, colour, disabilities, religion, sexual preferences
                and /or making sexual advances or otherwise engaging in sexual
                misconduct will not be tolerated on this Platform. Similarly,
                extorting or blackmailing any individual otherwise or on the
                basis of the abovementioned content is strictly prohibited.
              </p>
            </li>
            <li>
              <p>
                If someone blocks you from their account, kindly do not try and
                contact them from a different account. If a user does not want
                to engage with you on the Platform, we urge you to respect the
                same and vice versa.
              </p>
            </li>
            <li>
              <p>
                any image or information of a person that is shared without
                their consent with an intent to harass, distress or endanger
                them.
              </p>
            </li>
            <li>
              <p>
                false information posted to harass someone for financial gain,
                or cause any injury to them.
              </p>
            </li>
          </ol>
          <p>
            However, if a matter involves critical discussion and deliberation
            of such individuals who are featured in the news or tend to have a
            large public audience, we may allow it subject to the Terms and
            these Guidelines.
          </p>
          <h5>
            <strong>d. Intellectual Property</strong>
          </h5>
          <p>
            We want to protect intellectual property rights and consider
            infractions to be significant misbehaviour. Intellectual property
            protects all material, including literary, musical, dramatic,
            artistic, sound recordings, and cinematographic works.
          </p>
          <p>
            It is not permitted to post content on the Platform that is not
            original and has been copied from an individual or organisation that
            owns the intellectual property rights to such content/works. Any
            content that breaches the intellectual property rights of other
            parties will be removed, and repeat defaulters will face severe
            consequences. Please do not delete any attributions, watermarks, or
            original captions that specify the legitimate source of the material
            if you desire to reshare such content from inside the Platform.
            Furthermore, please get the necessary permissions and acknowledge
            fellow users or any other organisation/individual who possess the
            intellectual property rights in such work by citing their name
            and/or the original source.
          </p>
          <h5>
            <strong>e. Violence</strong>
          </h5>
          <p>
            Violence encompasses all content that causes discomfort to our users
            owing to its goriness, including but not limited to graphical
            pictures or films that celebrate violence and suffering, or attempt
            to encourage violence, depictions of physical violence, or animal
            cruelty. It is completely forbidden to post content that supports
            hazardous and unlawful acts, or that glorifies persons, groups, or
            leaders involved in terrorism, organised violence, or criminal
            activity.
          </p>
          <p>
            Educative or informative content pertaining to violence may be
            allowed on the Platform. Violent content on the Platform in the form
            of fictional set-up, martial arts, film, history and mythology may
            be permitted subject to these Guidelines.
          </p>
          <h5>
            <strong>f. Hate Speech and Propaganda</strong>
          </h5>
          <p>
            Content that promotes violent behaviour against an individual or a
            group of individuals, intends to intimidate, target or demean any
            particular religion, race, caste, ethnicity, community, nationality,
            disability (physical or mental), diseases or gender, is prohibited.
            Any kind of content which produces hatred or has the intention of
            creating or spreading hatred or hate propaganda along the lines of
            including, but not limited to religion, caste, ethnicity, community,
            sexual orientation, or gender identity is also not allowed. We do
            not entertain content that spreads discrimination, intends to
            justify violence based on the above-mentioned attributes and refers
            to an individual or a group of individuals as inferior in any sense
            or with negative connotations.
          </p>
          <p>
            We strongly advise you to avoid inflammatory discussion and
            promoting ideas or hateful beliefs that may enrage and negatively
            impact our users. We may allow content that aims to raise awareness
            about these problems or to criticise them, with the obvious goal of
            putting such information on the Platform.
          </p>
          <h5>
            <strong>g. Abuse, Self-Injury or Suicide</strong>
          </h5>
          <p>
            We do not allow information that promotes suicide or other suicidal
            inclinations, encourages self-injury and violence, or encourages
            involvement in harmful activities. It is strictly forbidden to post
            any content relating to physical, mental, sexual, or psychological
            maltreatment, neglect, or abuse of any person, whether a kid or an
            adult. Content displaying self-harm, promoting self-harm or suicide,
            or simply providing directions on how to do self-harm in any way is
            not permitted. Additionally, content that names, tags, attacks, or
            makes fun of victims and survivors of psychological/physical
            maltreatment, abuse, self-injury, domestic abuse, or any other type
            of violence is forbidden.
          </p>
          <p>
            We accept content that aims to provide support, assistance, and
            relief to anyone dealing with such significant difficulties. We also
            allow users to share their experiences, which may give coping
            methods for those in need, provided that such information is posted
            with the intention of assisting others.
          </p>
          <h5>
            <strong>h. Illegal Activities</strong>
          </h5>
          <p>
            We have a strict zero-tolerance policy for anything that encourages
            or promotes criminal acts. We do not allow information about
            organised crime, criminal activity, the promotion/sale/use of
            weapons, guns, and explosives, violence, or terrorist activities. It
            is completely prohibited to sell unlawful items or services,
            regulated commodities, narcotics and restricted substances, or
            solicit or sell sexual services. Content that is harassing, hurtful,
            or abusive to minors is not permitted. Users are not permitted to
            submit material that promotes or facilitates money laundering or
            gambling.
          </p>
          <p>
            Users are not permitted to publish information that presents
            tutorials or instructions or educates users about unlawful and
            forbidden behaviours such as participating in criminal activities,
            building explosives, or promoting, doing, or trafficking in
            narcotics. Do not use our Platform to solicit or assist any
            transaction or gift involving items and services that the Government
            of India has deemed unlawful.
          </p>
          <p>
            Impersonating another person (such as your family, friends,
            celebrities, brands, or any other individuals/organizations) and
            distributing false or misleading information on our Platform for
            commercial or personal benefit is deemed fraud. Content containing
            computer viruses, malware, or other computer code designed to limit
            the functionality of any computer resource is not permitted to be
            posted to the Platform.
          </p>
          <h5>
            <strong>i. Non-Consensual (Personal) Content</strong>
          </h5>
          <p>
            Posting or exploiting another person&apos;s personal content, data,
            or information, including images or videos of other persons who have
            not given express agreement to such material being displayed, is
            prohibited. Post no personal or intimate images or videos of anyone
            else without their knowledge or approval. Post no content that
            violates anyone&apos;s privacy. We will delete such content.
          </p>
          <p>
            Revealing someone&rsquo;s personal data or sensitive personal
            information, including without limitation: contact information,
            address, financial information, Aadhar Number, healthcare
            information, sexual or intimate images and videos, passport
            information, or threatening someone to reveal or use such
            information, will be considered as harassment, and such activities
            are strictly unacceptable.
          </p>
          <h5>
            <strong>j. Spam</strong>
          </h5>
          <p>
            Spam is defined as content that misleads consumers about its origin,
            shows or supports fake advertisements, fraudulent or misleading
            statements, and security breaches. When such stuff is posted for
            financial gain, it is considered commercial spam. Spam disrupts the
            Platform&apos;s operation and discourages other users from sharing
            and interacting. It is critical that the content you publish is
            genuine and contributes to the establishment of a secure and
            trustworthy environment for users to post on the Platform. Do not
            repeat material in order to irritate readers or offer goods/services
            in order to encourage spam, commercial or otherwise. Do not employ
            deceptive or manipulative methods to boost traffic or followers,
            likes, views, comments, and shares. If you want to promote your
            goods or services, we urge you to do so in an authentic manner.
          </p>
          <h5>
            <strong>k. Misinformation</strong>
          </h5>
          <p>
            On our Platform, we aim to combat the spread of misinformation. Any
            content that conveys purposeful misinformation, disinformation,
            hoaxes, or fake propaganda with the goal of misleading users or the
            wider public is prohibited. We prohibit the publication of anything
            that exaggerates an existing item of news by incorporating
            non-factual features.
          </p>
          <p>
            We do not allow content on the Platform that misleads users or
            attempts to create an avenue for fabricating content, or is
            defamatory, libellous, or attempts to damage someone&rsquo;s
            reputation, or hurt their financial or political standing on the
            basis of incorrect information. We engage third party fact checkers
            to combat the menace of fake news basis which we proactively warn
            our users that a piece of content is found to be factually
            incorrect. We urge you to take the same into consideration and act
            accordingly.
          </p>
          <p>
            However, we do not confuse fake news with any satire or parodies. We
            allow for such content on the Platform provided the content does not
            mislead other users and the intent behind the same is not to spread
            false information.
          </p>
          <h3>
            <strong>COMMUNITY GUIDELINES</strong>
          </h3>
          <p>
            When you use our Platform, we expect you to follow certain norms.
          </p>
          <h5>
            <strong>a. Use of Hashtag&nbsp;</strong>
          </h5>
          <p>
            Hashtags with the most appropriate and relevant tags should be
            utilized in all posts. If such a tag does not exist, one should be
            created. If reported, any material submitted with an irrelevant or
            inapplicable tag will be deleted from the stream.
          </p>
          <h5>
            <strong>b. Stay on Topic</strong>
          </h5>
          <p>
            Make sure that any content you publish and any discussions you
            participate in are relevant to the post&apos;s caption and tags.
            Content that does not connected to the caption or tags, or that is
            inappropriate for a specific post, will be deleted. Do not stray
            from the path.
          </p>
          <h5>
            <strong>c. Multiple/Fake Profiles</strong>
          </h5>
          <p>
            It is forbidden to create a false profile of an individual or
            organisation and to impersonate someone in a misleading or deceptive
            manner, with or without the goal of harassing or bullying them. We
            make exceptions for community accounts, instructive profiles, and
            public figure fan profiles. Satire or parody profiles of public
            individuals are also permissible, as long as the purpose is not to
            deceive other users and it is clearly stated in the profile
            description or status.
          </p>
          <h5>
            <strong>d. Safety and Security</strong>
          </h5>
          <p>
            Harassment or the use of abusive language in posts or comments while
            addressing another user is not permitted. Do not do anything that
            would make other users feel uneasy. If you attempt to create
            unpleasant conditions for other users, you will face consequences.
          </p>
          <h5>
            <strong>e. Beware of Legal Consequences</strong>
          </h5>
          <p>
            Ignorance of the law is not a justification for avoiding
            responsibility for your conduct. In order to use our Platform, you
            must abide with the rules and regulations that govern digital
            behaviour. Please follow all applicable laws when using our
            Platform. Any content that promotes, encourages, offers, promotes,
            glorifies, or solicits unlawful actions will not be accepted.
          </p>
          <h5>
            <strong>f. Evading Suspension</strong>
          </h5>
          <p>
            The user is bound by our decision to suspend any account. Any
            attempt to avoid suspension by creating other accounts, identities,
            personalities, or presence on another user&apos;s account may result
            in suspension as well. If you attempt to avoid suspension, we may be
            forced to terminate your account and prevent you from registering
            with us.
          </p>
          <h3>
            <strong>PLATFORM SECURITY</strong>
          </h3>
          <h5>
            <strong>Report</strong>
          </h5>
          <p>
            Please touch or click the REPORT button if you observe any content
            or behaviour that violates these Guidelines. We will get a notice
            and process your request as soon as you touch or click on this tab.
            If we determine that the content or conduct is inappropriate for our
            Platform, we will delete it. If you suspect that any content on the
            Platform violates your copyright rights, please contact our Support
            Team through Mail for further evaluation and action. There may be
            content on the Platform that you dislike, but it does not violate
            these Guidelines. In such a scenario, we ask that you unfollow or
            ban such persons.
          </p>
          <h5>
            <strong>Intermediary status &amp; Review of Content</strong>
          </h5>
          <p>
            We are an intermediary as per the applicable laws. We do not control
            what our users post, comment, share or say on the Platform and are
            not responsible for their (or your) actions (whether online or
            offline). We are not responsible for services and features offered
            by others even if you access them through our Services. Our
            responsibility and liability for anything that happens on our
            Platform is strictly governed and limited by the laws of India.
          </p>
          <p>
            We expect you to be responsible for what you post and what you see.
            If any of our users report your content to be against these
            Guidelines, we may take enforcement actions as necessary.
          </p>
          <h5>
            <strong>Right to Challenge</strong>
          </h5>
          <p>
            In case the content you upload or post, or your activity is reported
            by another user and removed from our Platform, we will notify you of
            such removal and our reasons for the same. If you believe that your
            content has been unfairly removed, you may write to us at
            support@utsavapp.in to challenge the removal. We may review the
            content again and determine if it may be reposted on the Platform.
          </p>
          <h5>
            <strong>Our Actions against Violators</strong>
          </h5>
          <p>
            We take strict and prompt action against those who violate these
            Guidelines. If your profile is reported for violating these
            Guidelines, then your profile may be suspended temporarily. In case
            of repeated breach of these Guidelines, we may be compelled to
            terminate your account with us permanently and block you from
            registering with us.
          </p>
          <p>
            If required, we will cooperate with legal authorities and law
            enforcement mechanisms. Please note that we are under no obligation
            to assist you.
          </p>
        </main>
      </seciton>

      <Footer data-sentry-element="Footer" data-sentry-source-file="ContentPolicy.jsx" />
    </div>;
}